import { withPopup } from '../lib/popup';

import UserUsernameEditStep from './UserUsernameEditStep';

export default withPopup(UserUsernameEditStep);
